<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Departamenty</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="mb-2 ml-3">Dodaj departament</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja departamentu</span>
					<span class="headline" v-else> Dodaj nowy departament</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field
									browser-autocomplete="off"
									:error-messages="vErrors.collect('name')"
									v-model="editedItem.name"
									v-on:input="discardDuplicateNameError"
									v-on:click="discardDuplicateNameError"
									label="Nazwa"
									aria-label="full name"
									for="departments-view-name"
									id="departments-view-name"
									v-validate="'required'"
									data-vv-name="name"
									data-vv-as="nazwa"/>
							</v-flex>
							<div v-if="showDuplicateNameMessage" style="color:red;">
								Departament o nazwie {{ editedItem.name }} już istnieje w systemie.
							</div>
							<v-flex xs12 sm6 md12>
								<v-text-field
									browser-autocomplete="off"
									v-model="editedItem.shortName"
									:error-messages="vErrors.collect('shortName')"
									v-on:input="discardDuplicateShortNameError"
									v-on:click="discardDuplicateShortNameError"
									label="Skrócona nazwa"
									aria-label="short name"
									for="departments-view-short-name"
									id="departments-view-short-name"
									v-validate="'required'"
									data-vv-name="shortName"
									data-vv-as="skrócona nazwa"/>
							</v-flex>
							<div v-if="showDuplicateShortNameMessage" style="color:red;">
								Departament o skróconej nazwie {{ editedItem.shortName }} już istnieje w systemie.
							</div>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="blue darken-1" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:loading="loading"
			:items="departments">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.shortName }}</td>
				<td>{{ props.item.name }}</td>
				<td>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								
								@click="deleteItem(props.item)" >
								<v-icon color="lightred" v-on="on">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="goToProfile(props.item.id)">
								<v-icon v-on="on">
									location_city
								</v-icon>
							</v-btn>
						</template>
						<span>Podgląd departmentu</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>

	</v-card>
</template>

<script>
	import {Department} from "../../../api/generated/Department";

	export default {

		name: "DepartmentsView",

		data() {
			return {
				dialog: false,
				loading: false,
				showDuplicateNameMessage: false,
				showDuplicateShortNameMessage: false,
				departments: [],
				tableHeaders: [
					{
						text: "Skrócona nazwa",
						sortable: false,
					},
					{
						text: "Nazwa",
						sortable: false,
					},
					{
						text: "Akcje",
						sortable: false,
					},
				],
				editedItem: {},

				editedIndex: -1,
			};
		},

		watch: {
			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
				this.discardDuplicateNameError();
				this.$validator.reset();
			},
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		methods: {
			goToProfile (id) {
				this.$router.push("/app/department-profile/" + id);
			},
			discardDuplicateNameError() {
				this.showDuplicateNameMessage = false;
				this.showDuplicateShortNameMessage = false;
			},

			discardDuplicateShortNameError() {
				this.showDuplicateShortNameMessage = false;
			},

			editItem(item) {
				this.editedIndex = this.departments.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć departament?", {
					icon: 'delete',
					title: 'Usuwanie departamentu',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							const index = this.departments.indexOf(item);
							Department.delete(this, item.id, successResponse => {
									this.departments.splice(index, 1);
									this.$messagesBus.$emit("success", "Departament został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć departamentu", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			save() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						if (this.editedIndex > -1) {
							Department.putEdit(this, this.editedItem, successResponse => {
								Object.assign(this.departments[this.editedIndex], this.editedItem);
								this.close();
								this.$messagesBus.$emit("success", "Departament został pomyślnie zapisany", successResponse);
							}, errorResponse => {
								if (errorResponse.errors.includes("NAME_NOT_UNIQUE")) {
									this.showDuplicateNameMessage = true;
								} else if (errorResponse.errors.includes("SHORT_NAME_NOT_UNIQUE")) {
									this.showDuplicateShortNameMessage = true;
								}
								this.$messagesBus.$emit("error", "Nie udało się zapisać departamentu", errorResponse);
							});
						} else {
							Department.postAdd(this, this.editedItem, successResponse => {
								this.editedItem.id = successResponse;
								this.departments.push(this.editedItem);
								this.close();
								this.$messagesBus.$emit("success", "Departament został pomyślnie dodany", successResponse);
							}, errorResponse => {
								if (errorResponse.errors.includes("NAME_NOT_UNIQUE")) {
									this.showDuplicateNameMessage = true;
								} else if (errorResponse.errors.includes("SHORT_NAME_NOT_UNIQUE")) {
									this.showDuplicateShortNameMessage = true;
								}
								this.$messagesBus.$emit("error", "Nie udało się dodać departamentu", errorResponse);
							});
						}
					}
				});
			},
		},

		created () {
			Department.getList(this, successResponse => {
					this.departments = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać listy departamentów", errorResponse);
				});

		},
	};
</script>

<style scoped>

</style>
